import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatInputModule } from '@angular/material/input'
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatRow,
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { ResponseRequestModel } from '../../../core/models/response.model'
import { MatProgressBar } from '@angular/material/progress-bar'
import { responseDefaultForm } from '../../../shared/utils/utils'
import { PersonDocumentService } from '../../../core/services/person/person-document/person-document.service'
import { DriverUploadCreateFormComponent } from './driver-upload-create-form/driver-upload-create-form.component'
import { downloadBase64File } from '../../../shared/utils/download_base64'

@Component({
  selector: 'driver-upload-edit',
  imports: [
    MatInputModule,
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatIcon,
    MatPaginator,
    MatRow,
    MatTable,
    MatTableModule,
    MatIcon,
    MatPaginatorModule,
    MatTable,
    MatProgressBar,
    DriverUploadCreateFormComponent,
  ],
  templateUrl: './driver-upload-edit.component.html',
  styleUrl: './driver-upload-edit.component.scss',
  providers: [PersonDocumentService],
  standalone: true,
})
export class DriverUploadEditComponent implements OnInit, AfterViewInit {
  constructor(
    private personDocumentService: PersonDocumentService,
    private snackbar: SnackbarCustomService,
  ) {}

  item: any = {}
  loading = true

  @Output() response = new EventEmitter<any>()
  @Input() idPerson = 0
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  columns: any[] = [
    {
      keyColumn: 'documentType',
      key: 'tipoDocDescricao',
      description: 'Tipo Documento',
    },
    {
      keyColumn: 'description',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'file',
      key: 'nomeArquivo',
      description: 'Arquivo',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]

  page = 1
  rows = 10
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  displayedColumns: string[] = ['description', 'file', 'documentType', 'action']

  listSearch: any = [
    {
      id: 'tipoContatoId',
      description: 'Tipo Contato',
      type: 'number',
      visible: false,
    },
    {
      id: 'descricao',
      description: 'Descrição',
      type: 'string',
      visible: true,
    },
  ]

  searchForm: any = { search: false, model: {} }
  inputSearchContact: any = { type: '', search: '' }

  ngOnInit(): void {
    this.getContactByPerson()
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    // if (this.table) {
    //   this.table.renderRows()
    // }
  }

  pageChanged($event: any) {
    this.page = $event.pageIndex + 1
    // this.rows = $event.pageSize
    this.uploadList()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchContact()
    } else {
      this.getContactByPerson()
    }
  }

  getContactByPerson() {
    this.loading = true
    // this.personDocumentService.listPersonDocumentbyId(this.idPerson).subscribe({
    this.personDocumentService
      .listPagedPersonDocumentById(this.idPerson, this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchContact() {
    this.loading = true
    this.personDocumentService
      .searchPagedPersonDocument(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({
          ...item,
        })
      }
    }
    this.tableSource = new MatTableDataSource<any>(list)
    this.refreshTable()
  }

  responseForm(response: any): void {
    if (response.refresh) {
      this.uploadList()
    }
    if (response.clear) {
      this.clearItem()
    }
  }

  downloadItem(element: any) {
    this.personDocumentService.downloadPersonDocument(element.id).subscribe({
      next: (response: any) => {
        downloadBase64File(
          response.fileContent,
          response.fileName,
          response.type,
        )
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  updateItem(element: any) {
    this.item = { edit: true, data: element }
  }

  deleteItem(element: any) {
    this.clearItem()
    this.personDocumentService
      .deletePersonDocument(element.id, { id: element.id })
      .subscribe({
        next: (response: any) => {
          this.snackbar.success(response.message)
          this.clearItem()
          this.uploadList()
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.snackbar.success(err.message)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  clearItem() {
    this.item = {}
  }

  createModel(element: any) {
    const model: any = { pessoaId: this.idPerson }
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }
}
